/*import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography, TextField, Button, Card, CardMedia, CardContent } from '@mui/material';
import axios from 'axios';*/
import React, { useEffect, useState, useRef, useCallback } from "react";
import { useParams } from "react-router-dom";
import axios from 'axios';
import { Box, Typography, TextField, Button, Link, Dialog, DialogTitle, DialogContent, DialogActions, Avatar, Card, CardMedia, CardContent } from '@mui/material';
import logo from "../components/Logo/Colloquia_Logo.png";
import Tooltip from '@mui/material/Tooltip';
import { useLocation, useHistory } from 'react-router-dom';


function VideosCommentsPage() {
    const { postId } = useParams(); // get :postId from URL
    const [post, setPost] = useState(null);
    const [newComment, setNewComment] = useState('');
    const [comments, setComments] = useState([]);

    const history = useHistory();
    const [open, setOpen] = useState(false);
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');


    const [openDialog, setOpenDialog] = useState(false);
    const [comment, setComment] = useState("");
    const [activePostId, setActivePostId] = useState(null);


    const [replyOpen, setReplyOpen] = useState(false);
    const [replyText, setReplyText] = useState("");
    const [activeCommentId, setActiveCommentId] = useState(null);

    useEffect(() => {
       axios.get(`/video/${postId}`)
           .then(res => setPost(res.data))
           .catch(err => console.error("Error loading case", err));
       }, [postId]);

    // Fetch comments
   /*useEffect(() => {
   axios.get(`/video/${postId}/comments`)
       .then(res => setComments(res.data))
       .catch(err => console.error("Error loading comments", err));
   }, [postId]);*/
   const [cursor, setCursor] = useState(null);
   const [loading, setLoading] = useState(false);
   const [hasMore, setHasMore] = useState(true);
   const fetchComments = async () => {
       if (loading || !hasMore) return;
       try {
           setLoading(true);
           const res = await axios.get(`/video/${postId}/comments`, {
               params: { cursor, limit: 10 }
           });
           setComments(prev => {
               const existingIds = new Set(prev.map(c => c._id));
               const newComments = res.data.comments.filter(c => !existingIds.has(c._id));
               return [...prev, ...newComments];
           });
           setCursor(res.data.nextCursor);
           setHasMore(res.data.hasMore);
       } catch (err) {
           console.error("Error loading comments", err);
       } finally {
           setLoading(false);
       }
   };
   useEffect(() => {
       setComments([]);
       setCursor(null);
       setHasMore(true);
   }, [postId]);
   useEffect(() => {
       fetchComments();
   }, [postId]);
   const observer = useRef();
   const lastCommentRef = useCallback(node => {
       if (loading) return;
       if (observer.current) observer.current.disconnect();
       observer.current = new IntersectionObserver(entries => {
           if (entries[0].isIntersecting && hasMore) {
           fetchComments();
           }
       });
       if (node) observer.current.observe(node);
   }, [loading, hasMore]);

   /*const handleSubmitComment = async () => {
       if (!newComment.trim()) return;

       try {
           const res = await axios.post(`/video/${postId}/comment`, { text: newComment }); // NOTE: single 'comment'
           setComments(prev => [res.data, ...prev]);
           setNewComment('');
       } catch (err) {
           console.error("Error submitting comment", err);
       }
   };*/
   const handleSubmitComment = async () => {
      if (!newComment.trim()) return;

      try {
          const res = await axios.post(`/video/${postId}/comment`, {
               text: newComment,
           });

          //const commentRes = await axios.get(`/video/${postId}/comments`);
          //setComments(commentRes.data);
          setComments(prev => [res.data, ...prev]);
          setNewComment('');
      } catch (err) {
          console.error("Error submitting comment", err);
      }
  };

   const toggleVote = async (postId) => {
       try {
           const res = await axios.post(`/videos/${postId}/upvote`);
           const { upvotes, voted } = res.data;


           setPost(prevCase => ({
               ...prevCase,
               upvotes,
               voted
           }));
       } catch (err) {
           console.error('Error toggling vote:', err);
       }
   };

   const handleOpenDialog = (scotusCaseId) => {
      setActivePostId(scotusCaseId);
      setOpenDialog(true);
   };


   /*const toggleCommentVote = async (commentId) => {
       try {
               // hit backend endpoint that toggles a vote
               const res = await axios.post(`/videoComments/${commentId}/upvote`);
               // update <posts> in react state so ui rerenders
               // setPosts(prev => ...) receives the previous array of posts and must return a new array
               // prev.map( p => { ... } )
               // iterate through every post p in old array
               // if p is the one user just voted on, return a new object with the fresh upvote info from server
               // otherwise, return p unchanged
           setComments((prev) =>
               prev.map((p) =>
                   p._id === commentId
                       ? {
                           ...p, // copy exisiting post fields
                           upvotes: res.data.upvotes, // updated count
                           voted:   res.data.voted // true or false that user voted
                       }
                       : p // all other posts unchanged
               )
           );
       } catch(err) {
           console.error("Vote error", err);
       }
   };*/
   const toggleCommentVote = async (commentId) => {
      try {
          const res = await axios.post(`/videoComments/${commentId}/upvote`);
          //const commentRes = await axios.get(`/video/${postId}/comments`);
          //setComments(commentRes.data);
          setComments(prev =>
                prev.map(c =>
                    c._id === commentId
                    ? { ...c, upvotes: res.data.upvotes, voted: res.data.voted }
                    : c
                )
            );
      } catch(err) {
          console.error("Vote error", err);
      }
  };

   const handleReplyOpen = (commentId) => {
       setActiveCommentId(commentId);
       setReplyOpen(true);
   };


   const handleReplyClose = () => {
       setReplyOpen(false);
       setReplyText("");
       setActiveCommentId(null);
   };



   const handleReplySubmit = async () => {
       if (!replyText.trim()) return;


       try {
       const res = await axios.post(`/video/comments/${activeCommentId}/replies`, {
           text: replyText
       });


       // Update state with new reply
       setComments(prev =>
           prev.map(c =>
           c._id === activeCommentId
               ? { ...c, replies: [...(c.replies || []), res.data] }
               : c
           )
       );


       handleReplyClose();
       } catch (err) {
       console.error("Reply error", err);
       }
   };

    // Submit new comment to backend
    const handleAddComment = async () => {
        if (!newComment.trim()) return; // prevent empty comments
        try {
            const res = await axios.post(`/video/${postId}/comment`, { text: newComment });
            setPost(prev => ({
                ...prev,
                comments: res.data, // update comment list from response
            }));
            setNewComment(''); // clear input
        } catch (err) {
            console.error("Failed to add comment", err);
        }
    };
  
    // Upvote the main post
    const handlePostUpvote = async () => {
        try {
            const res = await axios.post(`/video/${postId}/upvote`);
            setPost(prev => ({
            ...prev,
            upvoters: Array(res.data.upvotes).fill(1), // just update the count visually
            }));
        } catch (err) {
            console.error("Failed to upvote post", err);
        }
    };

    /*
    useEffect(() => {
        axios.get(`/video/${postId}`)
            .then(res => {
            const sortedComments = [...res.data.comments].sort(
                (a, b) => (b.upvoters?.length || 0) - (a.upvoters?.length || 0)
            );
            setPost({ ...res.data, comments: sortedComments });
            })
            .catch(err => console.error("Failed to load post", err));
    }, [postId]);


    // Submit new comment to backend
    const handleAddComment = async () => {
        if (!newComment.trim()) return; // prevent empty comments
        try {
            const res = await axios.post(`/video/${postId}/comment`, { text: newComment });
            setPost(prev => ({
                ...prev,
                comments: res.data, // update comment list from response
            }));
            setNewComment(''); // clear input
        } catch (err) {
            console.error("Failed to add comment", err);
        }
    };
  
    // Upvote the main post
    const handlePostUpvote = async () => {
        try {
            const res = await axios.post(`/video/${postId}/upvote`);
            setPost(prev => ({
            ...prev,
            upvoters: Array(res.data.upvotes).fill(1), // just update the count visually
            }));
        } catch (err) {
            console.error("Failed to upvote post", err);
        }
    };

    // Upvote a comment
    const handleCommentUpvote = async (commentId) => {
        try {
            const res = await axios.post(`/video/${postId}/comment/${commentId}/upvote`);
            setPost(prev => ({
            ...prev,
            comments: prev.comments.map(c =>
                c._id === commentId
                ? { ...c, upvoters: Array(res.data.upvotes).fill(1) }
                : c
            ),
            }));
        } catch (err) {
            console.error("Failed to upvote comment", err);
        }
    };
    */
    const [videoFile, setVideoFile] = useState(null);
    const [description, setDescription] = useState("");

    const [thumbnailFile, setThumbnailFile] = useState(null);

    const [videoFileName, setVideoFileName] = useState("");
    const [thumbnailFileName, setThumbnailFileName] = useState("");

    const handleUpload = async () => {
        if (!videoFile) return;

        const formData = new FormData();
        formData.append('video', videoFile);
        if (thumbnailFile) {
            formData.append("thumbnail", thumbnailFile);
        }
        formData.append('description', description);
        formData.append('title', title);

        try {
        const res = await axios.post('/videos/upload', formData);
        console.log("Upload success:", res.data);
        setOpen(false); // close dialog
        } catch (err) {
        console.error("Upload failed:", err);
        }
    };

    const visitProfile = (e, userId) => {
        e.stopPropagation(); // prevent opening the post
        history.push(`/user/view/${userId}`);
    };

  if (!post) return <Typography>Loading...</Typography>;

  const location = useLocation();
   const source = location.state?.source;
    const navItems = [
        {
            label: "Popular",
            path: "/mainsocial/videos/popular",
            matchPaths:
            source === "popular"
                ? ["/mainsocial/videos/popular", "/videos"]
                : ["/mainsocial/videos/popular"]
        },
        {
            label: "Following",
            path: "/mainsocial/videos/following",
            matchPaths:
            source === "following"
                ? ["/mainsocial/videos/following", "/videos"]
                : ["/mainsocial/videos/following"]
        },
    ];

    const getButtonStyles = (item) => {
      //const active = location.pathname.startsWith(path);
      const active = item.matchPaths
        ? item.matchPaths.some(path => location.pathname.startsWith(path))
        : location.pathname.startsWith(item.path);

      return {
        padding: "6px 12px",
        borderColor: active ? "#1f1f1f" : "#333333",
        color: active ? "#1f1f1f" : "#333333",
        backgroundColor: active ? "rgba(0,0,0,0.08)" : "transparent",
        fontWeight: active ? 600 : 500,
        transition: "all 0.15s ease",
        "&:hover": {
          borderColor: "black",
          color: "black",
          backgroundColor: "rgba(0,0,0,0.12)"
        }
      };
    };
  return (
       <div
          style={{
              padding: '20px',
              backgroundColor: '#FFFDF8',
              minHeight: '100vh',  // ensures it covers the full viewport height
              boxSizing: 'border-box', // ensures padding doesn't affect layout
          }}
      >

          <div style={{ width: '200px' }}></div>

          {/* Centered Buttons */}
            {/*<Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap={2}
                flexWrap="wrap"
                sx={{
                    mt: 4,
                    mb: 4,
                }}
                    >
                      <Button 
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/videos/popularVideos')}
                      >
                        Popular
                      </Button>
                      <Button 
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/videos/followingVideos')}
                      >
                        Following
                      </Button>
                      <Button 
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => setOpen(true)}
                      >
                        Post Video
                      </Button>*/}
{/* Sticky Navigation */}
              <Box
                sx={{
                  position: "sticky",
                  top: 0,
                  zIndex: 1000,
                  backgroundColor: "#FFFDF8",
                  //borderBottom: "1px solid rgba(0,0,0,0.08)",
                  py: 2
                }}
              >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        maxWidth: "100%",
                    }}
                >
                    {/* LEFT — LOGO */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            minWidth: 220, // keeps layout stable
                        }}
                    >
                        <Tooltip
                            title="Lady Wisdom"
                            arrow
                            followCursor
                        >
                            <Box
                                component="img"
                                src="/Colloquia_Logo.png"
                                alt="Colloquia Logo"
                                onClick={() => history.push("/home")}
                                sx={{
                                    height: 90,
                                    width: "auto",
                                    borderRadius: "10px", // rounded edges
                                    cursor: "pointer",
                                    objectFit: "contain",
                                }}
                            />
                        </Tooltip>
                    </Box>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  gap={2}
                  flexWrap="wrap"
                >
                  {navItems.map((item) => (
                    <Button
                      key={item.path}
                      variant="outlined"
                      sx={getButtonStyles(item)}
                      onClick={() => history.push(item.path)}
                    >
                      {item.label}
                    </Button>
                  ))}

                  <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => setOpen(true)}
                    >
                        Post Video
                    </Button>
                </Box>
                <Box sx={{ minWidth: 220 }} />
              </Box>
              </Box>
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                backgroundColor: "#FFFDF8",
                borderRadius: 3,
                },
            }}
            >
            <DialogTitle sx={{ fontWeight: "bold" }}>
                Upload a Video
            </DialogTitle>

            <DialogContent
                sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                pt: 1,
                }}
            >
                {/* Upload Video */}
                <Button variant="outlined" component="label">
                Upload Video
                <input
                    type="file"
                    accept="video/*"
                    hidden
                    onChange={(e) => {
                    const file = e.target.files[0];
                    setVideoFile(file);
                    setVideoFileName(file?.name || "");
                    }}
                />
                </Button>

                {videoFileName && (
                <Typography variant="caption" color="text.secondary">
                    Selected video: {videoFileName}
                </Typography>
                )}

                {/* Upload Thumbnail */}
                <Button variant="outlined" component="label">
                Upload Thumbnail (optional)
                <input
                    type="file"
                    accept="image/*"
                    hidden
                    onChange={(e) => {
                    const file = e.target.files[0];
                    setThumbnailFile(file);
                    setThumbnailFileName(file?.name || "");
                    }}
                />
                </Button>

                {thumbnailFileName && (
                <Typography variant="caption" color="text.secondary">
                    Selected thumbnail: {thumbnailFileName}
                </Typography>
                )}

                <TextField
                    label="Title"
                    fullWidth
                    multiline
                    rows={2}
                    value={title}
                    onChange={(e) => {
                        const value = e.target.value;
                        if (value.length <= 100) {
                        setTitle(value);
                        }
                    }}
                    inputProps={{
                        maxLength: 100,
                    }}
                    helperText={`${title.length}/100 characters`}
                    FormHelperTextProps={{
                        sx: { textAlign: 'right' }
                    }}
                    error={title.length === 100} // Optional: turn red when at limit
                />

                <TextField
                label="Description"
                fullWidth
                multiline
                rows={3}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                />
            </DialogContent>

            <DialogActions>
                <Button onClick={() => setOpen(false)}>Cancel</Button>
                <Button onClick={handleUpload} variant="contained">
                Post Video
                </Button>
            </DialogActions>
            </Dialog>
      {/*</Box>*/}

           <Box
               p={2} // padding inside box
               my={2} // vertical margin between posts
               border="1px solid #ccc" // light grey border
               borderRadius="8px" // rounded corners
               sx={{
                   position: "relative",
                   maxWidth: 900, // limit width
                   mx: "auto", // center horizontally
                   my: 2, // vertical spacing between each post
               }}
           >
                <Box display="flex" alignItems="flex-start" gap={1}>
              <Avatar
                src={post.author?.profileImageUrl || '/default-avatar.jpg'}
                alt={`${post.author?.first_name || ''} ${post.author?.last_name || ''}`}
                onClick={(e) => visitProfile(e, post.author?._id)}
                                sx={{ 
                                    width: 62, 
                                    height: 62,
                                    cursor: "pointer",
                                    "&:hover": {
                                        backgroundColor: "#d9e4f0",
                                    }, 
                                    }}
              />
              <Box>
               <Typography variant="subtitle1" fontWeight="bold"
               onClick={(e) => visitProfile(e, post.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "inline-block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "currentColor", 
                                    textUnderlineOffset: "3px",
                                    },
                                }}
               >
                {post.author?.first_name && post.author?.last_name
                  ? `${post.author.first_name} ${post.author.last_name}`
                  : 'Unknown Name'}
               </Typography>
               <Typography variant="body2" color="text.secondary"
               onClick={(e) => visitProfile(e, post.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "#currentColor",
                                    textUnderlineOffset: "3px",
                                    },
                                }}
               >
                @{post.author?.username || 'unknown'}
               </Typography>

               </Box>
            </Box>

            <Typography variant="subtitle1">
                                {post.title}
                            </Typography>

                            <CardMedia
                                component="video"
                                controls
                                //src={`http://localhost:3000${post.videoUrl}`}
                                src={post.videoUrl}
                                sx={{
                                    maxWidth: 900,       // large but still constrained
                                    width: '100%',
                                    display: 'block',
                                    margin: '16px auto 0 auto', // centers horizontally, adds top space
                                    borderRadius: 2,
                                    objectFit: 'contain'
                                }}
                            />

            <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
              {post.description}
            </Typography>

            {/*<Typography
              variant="caption"
              color="text.secondary"
              sx={{ display: "block", mt: 0.5 }}
            >
             {`${new Date(post.createdAt).toLocaleString()}, ${post.comments.length} ${post.comments.length === 1 ? 'reply' : 'replies'}`}
            </Typography>*/}
            <Typography
                variant="caption"
                color="text.secondary"
                sx={{ display: "block", mt: 0.5 }}
            >
                {`${new Date(post.created_at).toLocaleString()}, ${
                    post.commentCount
                  } ${post.commentCount === 1 ? 'reply' : 'replies'}`}
            </Typography>

                   {/*<Box mt={2} display="flex" alignItems="center" gap={1}>
                       <Button
                           size="small"
                           variant={post.voted ? "contained" : "outlined"}
                           //onClick={() => toggleVote(post._id)}
                           onClick={(e) => {
                               e.stopPropagation();
                               toggleVote(post._id)}
                           }
                       >
                           ▲ {post.voted ? "Unvote" : "Upvote"}
                       </Button>
                       <Typography variant="body2">{post.upvotes} upvotes</Typography>
                   </Box>*/}
            <Box mt={2} display="flex" alignItems="center" gap={1}>
                        {post.voted ? (
                            <Box
                               sx={{
                                   position: "relative",
                                   display: "inline-flex",
                                   alignItems: "center",
                                   "&:hover .voted-btn": {
                                       opacity: 0,
                                   },
                                   "&:hover .undo-btn": {
                                       opacity: 1,
                                       pointerEvents: "auto",
                                   },
                               }}
                           >
                                <Button
 					                size="small"
                                    className="voted-btn"
                                    variant="contained"
                                    color="success"
                                    disabled
                                    sx={{
                                       transition: "opacity 0.2s ease",
                                    }}
                                >
                                   Power Voted
                               </Button>
                               <Button
                                    size="small"
                                    className="undo-btn"
                                    variant="contained"
                                    color="error"
                                    sx={{
                                       inset: 0,
                                       position: "absolute",
                                       transition: "opacity 0.2s ease",
                                       opacity: 0,
                                       pointerEvents: "none",
                                   }}
                                   onClick={(e) => {
                                       e.stopPropagation();
                                       toggleVote(post._id)
                                   }}
                               >
                                    Undo
                               </Button>
                           </Box>
                        ) : (
                            <Button
                                size="small"
                                variant="outlined"
                                onClick={(e) => {
                                e.stopPropagation();
                                toggleVote(post._id)}
                            }
                            >
                                ▲ Power Vote
                            </Button>
                        )}
                        <Typography variant="body2">{post.upvotes} Power Votes</Typography>
                   </Box>
           </Box>

           <Box
               p={2} // padding inside box
               my={2} // vertical margin between posts
               border="1px solid #ccc" // light grey border
               borderRadius="8px" // rounded corners
               sx={{
                   position: "relative",
                   maxWidth: 900, // limit width
                   mx: "auto", // center horizontally
                   my: 2, // vertical spacing between each post
               }}
           >
           <TextField
               fullWidth
               multiline
               rows={2}
               placeholder="Engage in intellectual discourse..."
               value={newComment}
               onChange={e => setNewComment(e.target.value)}
           />
           <Button variant="outlined" sx={{ mt: 1 }} onClick={handleSubmitComment}>
               Reply
           </Button>
           </Box>

           {comments.length === 0 ? (
               <Typography></Typography>
           ) : (
               comments.map((comment, i) => {
                const isLast = i === comments.length - 1;
                return (
               <Box
                   p={2} // padding inside box
                   ref={isLast ? lastCommentRef : null}
                   //onClick={() => history.push(`/video/${postId}/comments/${comment._id}`)}
                   onClick={() => history.push(`/video/${postId}/comments/${comment._id}`, { source: source })}
                   my={2} // vertical margin between posts
                   border="1px solid #ccc" // light grey border
                   borderRadius="8px" // rounded corners
                   sx={{
                       position: "relative",
                       maxWidth: 900, // limit width
                       mx: "auto", // center horizontally
                       my: 2, // vertical spacing between each post
                       cursor: "pointer",
                       "&:hover": {
                           backgroundColor: "#f9f9f9"
                       }
                   }}
           >

                   <Box display="flex" alignItems="flex-start" gap={1}>
                               <Avatar
                                   src={comment.author?.profileImageUrl || '/default-avatar.jpg'}
                                   alt={`${comment.author?.first_name || ''} ${comment.author?.last_name || ''}`}
                                   onClick={(e) => visitProfile(e, comment.author?._id)}
                                    sx={{ 
                                        width: 62, 
                                        height: 62,
                                        cursor: "pointer",
                                        "&:hover": {
                                            backgroundColor: "#d9e4f0",
                                        }, 
                                        }}
                               />
                               <Box>
                                   <Typography variant="subtitle1" fontWeight="bold"
                                   onClick={(e) => visitProfile(e, comment.author?._id)}
                                    sx={{
                                        cursor: "pointer",
                                        display: "inline-block",
                                        "&:hover": {
                                        textDecoration: "underline",
                                        textDecorationColor: "currentColor", 
                                        textUnderlineOffset: "3px",
                                        },
                                    }}
                                   >
                                   {comment.author?.first_name && comment.author?.last_name
                                       ? `${comment.author.first_name} ${comment.author.last_name}`
                                       : 'Unknown Name'}
                                   </Typography>
                                   <Typography variant="body2" color="text.secondary"
                                   onClick={(e) => visitProfile(e, comment.author?._id)}
                                    sx={{
                                        cursor: "pointer",
                                        display: "block",
                                        "&:hover": {
                                        textDecoration: "underline",
                                        textDecorationColor: "#currentColor",
                                        textUnderlineOffset: "3px",
                                        },
                                    }}
                                   >
                                   @{comment.author?.username || 'unknown'}
                                   </Typography>

                                   <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
                                       {comment.text}
                                   </Typography>

                                   <Typography
                                        variant="caption"
                                        color="text.secondary"
                                        sx={{ display: "block", mt: 0.5 }}
                                    >
                                        {`${new Date(comment.created_at).toLocaleString()}, ${
                                            comment.replyCount
                                        } ${comment.replyCount === 1 ? 'reply' : 'replies'}`}
                                    </Typography>

                               </Box>
                           </Box>

                           {/*<Box mt={2} display="flex" alignItems="center" gap={1}>
                               <Button
                                   size="small"
                                   variant={comment.voted ? "contained" : "outlined"}
                                   onClick={(e) => {
                                       e.stopPropagation();
                                       toggleCommentVote(comment._id)}
                                   }
                               >
                                   ▲ {comment.voted ? "Unvote" : "Upvote"}
                               </Button>
                               <Typography variant="body2">{comment.upvotes} upvotes</Typography>
                           </Box>*/}
                            <Box mt={2} display="flex" alignItems="center" gap={1}>
                            {comment.voted ? (
                                <Box
                                sx={{
                                    position: "relative",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    "&:hover .voted-btn": {
                                        opacity: 0,
                                    },
                                    "&:hover .undo-btn": {
                                        opacity: 1,
                                        pointerEvents: "auto",
                                    },
                                }}
                            >
                                    <Button
                                        size="small"
                                        className="voted-btn"
                                        variant="contained"
                                        color="success"
                                        disabled
                                        sx={{
                                        transition: "opacity 0.2s ease",
                                        }}
                                    >
                                    Power Voted
                                </Button>
                                <Button
                                        size="small"
                                        className="undo-btn"
                                        variant="contained"
                                        color="error"
                                        sx={{
                                        inset: 0,
                                        position: "absolute",
                                        transition: "opacity 0.2s ease",
                                        opacity: 0,
                                        pointerEvents: "none",
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        toggleCommentVote(comment._id)
                                    }}
                                >
                                        Undo
                                </Button>
                            </Box>
                            ) : (
                                <Button
                                    size="small"
                                    variant="outlined"
                                    onClick={(e) => {
                                    e.stopPropagation();
                                    toggleCommentVote(comment._id)}
                                }
                                >
                                    ▲ Power Vote
                                </Button>
                            )}
                            <Typography variant="body2">{comment.upvotes} Power Votes</Typography>
                    </Box>

               </Box>
               )})
           )}
    </div>
);
/*
  return (
    <Box p={4}>

      <Box mb={4} p={2} border="1px solid #ccc" borderRadius="8px">
        <Typography variant="subtitle1" fontWeight="bold">
          @{post.author?.username || "Unknown"}
        </Typography>
        <CardMedia
            component="video"
            controls
            src={`http://localhost:3000${post.videoUrl}`}
            alt="User Video"
            sx={{
                width: '100%',
                maxHeight: 500,
                objectFit: 'contain', 
                backgroundColor: '#000', 
            }}
        />
        <Typography variant="caption" display="block">
          {new Date(post.created_at).toLocaleString()}
        </Typography>
        <Typography mt={1} variant="body2">
          👍 {post.upvoters?.length || 0} upvotes
        </Typography>
        <Button variant="outlined" size="small" onClick={handlePostUpvote}>
            Upvote
        </Button>
      </Box>


      <Box mb={2}>
        <TextField
          label="Add a comment"
          variant="outlined"
          fullWidth
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
        />
        <Button
          variant="contained"
          onClick={handleAddComment}
          sx={{ mt: 1 }}
        >
          Submit
        </Button>
      </Box>


      {post.comments.map((comment, i) => (
        <Box key={i} ml={2} mt={1}>
            <Typography variant="body2">
                <strong>@{comment.author?.username || "Anonymous"}:</strong> {comment.text}
            </Typography>
                <Typography variant="caption" display="block">
                    👍 {comment.upvoters?.length || 0} upvotes
                </Typography>
                <Button
                    variant="outlined"
                    size="small"
                    onClick={() => handleCommentUpvote(comment._id)}
                >
                    Upvote
                </Button>
        </Box>
    ))}
    </Box>
  );
  */
}

export default VideosCommentsPage;
